{
  "settings": {
    "2fa": {
      "buttons": {
        "disable": "Disable",
        "setUp": "Enable",
        "yesDisable": "Yes, disable"
      },
      "characterCode": "6-character code",
      "description2FaOff": "Add an extra layer of security to your account. To sign in, you'll need to provide a code along with your username and password.",
      "description2FaOn": "You have enabled two-factor authentication. To sign in, you'll need to provide a verification code from your authenticator app along with your username and password.",
      "disableDesc": "This reduces the security level of your account and is not recommended. Are you sure you want to continue?",
      "disableTitle": "Disable two-factor authentication",
      "header": "2FA",
      "orCopy": "Or copy code for manual entry:",
      "qrCodeDesc": "Using an authenticator app like Google Authenticator, scan the QR code.",
      "setUpLong": "Set up two factor authentication",
      "title": "Two Factor Authentication",
      "verificationDesc": "Once you have connected your app, enter your most recent 6 digit verification code for North House.",
      "restore": {
        "title": "Need help accessing your account?",
        "description": "If you're unable to access your account due to two-factor authentication issues, please contact our support team at support@northhouse.se or call +46 (0)8 50 23 52 22"
      },
      "copy": "Copy"
    },
    "header": "Settings",
    "password": {
      "title": "Password",
      "description": "Here you can change your password.",
      "current": "Current password",
      "enterCurrent": "Enter current password",
      "enterNew": "Enter new password",
      "header": "Password",
      "mustContain": "Must contain a minimum of 8 characters, at least 1 uppercase, 1 lowercase and 1 numeric character.",
      "new": "New password",
      "repeat": "Repeat new password",
      "noMatch": "Passwords don't match",
      "tooShort": "Password must be at least 8 characters long",
      "needsUppercase": "Password must contain at least one uppercase letter",
      "needsLowercase": "Password must contain at least one lowercase letter",
      "needsNumber": "Password must contain at least one number"
    },
    "profile": {
      "description": "This is how others will see you on the site.",
      "avatar": "Avatar",
      "changeImage": "Change",
      "email": "Email",
      "header": "Profile",
      "name": "Name",
      "firstName": "First name",
      "lastName": "Last name",
      "position": "Position",
      "role": "Your role",
      "title": "Profile"
    },
    "roleDescription": {
      "superadmin": "Administrator of the platform. Can read and be assigned roles in all documents.",
      "coordinator": "Can own, read and be assigned roles in all documents.",
      "contributor": "Can own, read and be assigned roles in documents that are in the same category as the user.",
      "reader": "Can read documents that are in the same category as the user."
    },
    "userManagement": {
      "activateUser": "Activate user",
      "deleteUser": "Delete user",
      "deleteUserSupText": "Are you sure you want to delete the following user?",
      "descriptionPartDisable": "Are you sure you want to disable this user?",
      "descriptionPartEnable": "Are you sure you want to activate this user?",
      "disableUser": "Disable user",
      "search": "Search users...",
      "title": "Users",
      "addUser": {
        "title": "Add user"
      },
      "editUser": {
        "title": "Edit user"
      },
      "hasDocumentRoles": "This user has a role in the following documents. Please remove the user from these documents before proceeding."
    }
  }
}
